import React, { useEffect, useState } from "react";

import AddCircleIcon from "@material-ui/icons/AddCircle";
import Button from "@material-ui/core/Button";

import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

import { useConfirmationContext } from "components/ConfirmationDialog/ConfirmationContext";
import Dialog from "components/Dialog";
import { useLoggedInUser } from "components/LoggedInUserProvider";
import InjectionForm from "./InjectionForm";

import useStyles from "./styles";

export interface Props {
  horse: racehorse360.IHorse;
  injection?: racehorse360.IInjection;
  type: racehorse360.MedicineType;
  isEdit?: boolean;
  isOpen?: boolean;
  onClose?: () => void;
}

const InjectionFormModal = (props: Props) => {
  const { horse, type, isEdit, isOpen, onClose, injection = {} } = props;
  const { currentUser } = useLoggedInUser();
  const { confirmationRequired, openConfirmation } = useConfirmationContext();

  const classes = useStyles();

  const isBooster = type === racehorse360.MedicineType.MEDICINE_TYPE_BOOSTER;
  const [open, setOpen] = useState<boolean>(false);

  useEffect(() => {
    if (isOpen !== undefined) {
      setOpen(isOpen);
    }
  }, [isOpen]);

  const toggleModal = () => {
    if (confirmationRequired) {
      openConfirmation();
      return;
    }

    if (open) {
      onClose?.();
    }

    setOpen(prevValue => !prevValue);
  };

  const closeModal = () => {
    onClose && onClose();
    setOpen(false);
  };

  const handleClose = () => {
    if (confirmationRequired) {
      openConfirmation();
    } else {
      toggleModal();
    }
  };

  return (
    <>
      {!isEdit && (
        <Button
          className={
            isBooster ? classes.addBoosterButton : classes.addVaccineButton
          }
          classes={{
            root: classes.addEntryButtonRoot,
            label: classes.addEntryButtonLabel,
            disabled: classes.addEntryButtonDisabled
          }}
          onClick={toggleModal}
          variant={"outlined"}
          endIcon={isBooster ? null : <AddCircleIcon />}
          disabled={currentUser.isRegulatoryVet}
        >
          Add {isBooster ? "Booster" : "Vaccine"}
        </Button>
      )}
      {isEdit && !isBooster && (
        <Button className={classes.buttonEditEntry} onClick={toggleModal}>
          Edit Entry
        </Button>
      )}
      <Dialog
        title={`${isEdit ? "Edit" : "Add"} ${
          isBooster ? "Booster" : "Vaccination"
        } Record`}
        onClose={handleClose}
        classes={{
          title: classes.dialogTitle,
          paper: classes.dialogPaper,
          content: classes.dialogContent
        }}
        isOpen={open}
      >
        <InjectionForm
          horse={horse}
          injection={injection}
          type={type}
          isEdit={isEdit}
          onCancel={handleClose}
          closeModal={closeModal}
        />
      </Dialog>
    </>
  );
};

export default InjectionFormModal;
